module.exports = __webpack_public_path__ + "media/packs/images/flags/IT-d33f85f0a4247dfe7b3be41d515abd58.png";